<script>
  /* Executable code section of the program */
  //Component importation
  import Loader from "../components/Loader.svelte";
  import ChatModal from "../components/Modals/ModalChat.svelte";
  import AlertModal from "../components/Modals/AlertModal.svelte";
  

  //Tools importation
  import {
    isAlertOn,
    isChatModalOn,
    isProtectedRoute,
    meetsArray,
    userLocalData,
    userRealTime,
    eventRealTime,
    temporalData,
  } from "../apis/storage";
  import {
    auth,
    getOneDocument,
    getSpecificDocuments,
    listenToDocument,
    breaksNameFunction,
  } from "../apis/APIS";
  import { onAuthStateChanged } from "firebase/auth";
  import { onDestroy, onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import MeetsCard from "../components/Cards/MeetsCard.svelte";
  import { element } from "svelte/internal";

  //Auxiliary Variables
  let isLoadedContent = false;
  let dinamicMeets = [];
  let saveData = [];
  let breaksNames = [];
  let pathname;
  let currentEvent = {}

  //Listener variables
  let unsubscribeUser;
  let finalButtons 
  let isActiveMeetButton
  let isActivePolls
  let event
  let unsubscribeEvent
  let colorBtn
  let eventWallpaper

//Funtion to filter custom buttons
const filterButtons = (event) => {
return event.eventButtons.filter((element) => {
if (!element.isAvailable) return false;

if (
  element.buttonTittle === "Meetings" &&
  $userLocalData[0].userRole === "attendee" &&
  !$userRealTime.availableMeet
) {
  return false;
}

return true;
});
};

  //Reset function
  const resetDocuments = async () => {
    document.querySelector(".statusSelect").value = "";
    document.querySelector(".breakSelect").value = "";
    

    dinamicMeets = sortMeetings(saveData);
  };

  const filterAttendees = async () => {
    try {
      const statusSelect = document.querySelector(".statusSelect");
      const breakSelected = document.querySelector(".breakSelect").value;
      if (!statusSelect) {
        throw new Error("Status select element not found in the DOM.");
      }

      const selectedStatus = statusSelect.value;

      if (selectedStatus === "") {
        console.warn("No status selected. Returning full data set.");
        dinamicMeets = saveData;
        return saveData;
      } else {
        let filteredAttendees = [];

        if (breakSelected === "") {
          filteredAttendees = saveData.filter(
            ({ meetStatus }) => meetStatus === selectedStatus
          );
        } else {
          filteredAttendees = saveData.filter(
            ({ meetStatus, breakId }) =>
              meetStatus === selectedStatus && breakId === breakSelected
          );
        }

        // Optionally update your dynamic data here
        dinamicMeets = filteredAttendees;

        return filteredAttendees;
      }
    } catch (error) {
      console.error("❌ Error filtering attendees:", error.message);
      return [];
    }
  };

  // ✅ Función para traer reuniones por IDs desde Firestore
  const fetchMeetsByIds = async (ids) => {
    if (!Array.isArray(ids) || ids.length === 0) return;

    try {
      const fetched = await Promise.all(
        ids.map((id) => getOneDocument("meetings", id))
      );
      saveData = fetched.filter(Boolean);
      saveData = saveData.filter(
        (element) => element.event === $eventRealTime.tittle
      );
      /*     */
      dinamicMeets = fetched.filter(Boolean); // elimina nulls si algún doc no existe
      dinamicMeets = dinamicMeets.filter(
        (element) => element.event === $eventRealTime.tittle
      );
      dinamicMeets = sortMeetings(dinamicMeets)
      /*    */
    } catch (err) {
      console.error("❌ Error fetching meetings:", err);
    }
  };

  // ✅ Reacción automática cuando $meetsArray cambia
  $: {
    if ($meetsArray?.length > 0) {
      fetchMeetsByIds($meetsArray);
    }
  }

  //Function to go back
  const goBack = () => {
    window.location.reload()
    window.history.back();
  };

  // function to filter meetings for break
  const filterMeetingsForBreak = async () => {
    try {
      const breakSelected = document.querySelector(".breakSelect");
      const statusSelected = document.querySelector(".statusSelect").value;
      if (!breakSelected) {
        throw new Error("Status select element not found in the DOM.");
      }      
      const selectedValue = breakSelected.value;

      if (selectedValue === "") {
        console.warn("No status selected. Returning full data set.");
        dinamicMeets = saveData;
        return saveData;
      } else {
        let filteredAttendees = [];
        if (statusSelected === "") {        
          filteredAttendees = saveData.filter(
            ({ breakId }) => breakId === selectedValue
          );
        } else {
          filteredAttendees = saveData.filter(
            ({ breakId, meetStatus }) => breakId === selectedValue && meetStatus === statusSelected
          );
        }

        // Optionally update your dynamic data here
        dinamicMeets = filteredAttendees;

        return filteredAttendees;
      }
    } catch (error) {
      console.error("❌ Error filtering attendees:", error.message);
      return [];
    }
  };

  /* Function to organize the meets */
  const sortMeetings =(array) => {
  const statusPriority = {
    accepted: 0,
    pending: 1,
    declined: 2
  };

  return array.sort((a, b) => {
    const statusA = statusPriority[a.meetStatus] ?? 3;
    const statusB = statusPriority[b.meetStatus] ?? 3;

    if (statusA !== statusB) {
      return statusA - statusB;
    }

    // If status is the same, compare by startTime
    const timeA = a.meetingTime?.startTime ?? "";
    const timeB = b.meetingTime?.startTime ?? "";

    return timeA.localeCompare(timeB);
  });
}

  //Logged-in session verification
  //Initial function execution
  onMount(async () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        
    window.scrollTo({ top: 0, behavior: "smooth" });
        $isProtectedRoute = true;
        $userLocalData = await getSpecificDocuments(
          "users",
          "email",
          user.email
        );
        pathname = window.location.pathname.split("/")[2];
        //Get even information
        $eventRealTime = await getOneDocument("events", pathname);

        //Get name for the meeting breaks
        breaksNames = await breaksNameFunction($eventRealTime.tittle);

        unsubscribeUser = listenToDocument(
          "users",
          $userLocalData[0].id,
          (data) => {
            $userRealTime = data;
            $meetsArray = $userRealTime.scheduledMeetings; /* 
          dinamicMeets = $meetsArray */
          }
        );

        unsubscribeEvent = listenToDocument(
          "events",
          pathname,
          (data) => {
            event = data
        eventWallpaper = event.eventMultimedia.eventWallpaperUrl || "";
        colorBtn = event.colorEvent || "";
        currentEvent = data

        isActiveMeetButton = event.eventButtons.some((element) =>{
          return (element.buttonTittle === "Meetings")  &&
          element.isAvailable 
          });
          
        //Polls active verificator
         isActivePolls = event.eventButtons.some((element) => element.buttonTittle === "Polls" && element.isAvailable);

        //Funtion to filter custom buttons
        finalButtons = filterButtons(data);
        
          }
        );

        setTimeout(() => (isLoadedContent = true), 1500);
      } else {
        navigate("/");
      }
    });
  });
  onDestroy(() => {
    if (unsubscribeUser) unsubscribeUser(); // Clean listener
    if (unsubscribeEvent) unsubscribeEvent() // Clean listener
  });
  

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $isProtectedRoute}
  {#if isLoadedContent}
    <body class="principalSection">
      <div class="backBtnContainer">
        <button class="backBtn" on:click={goBack}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
            />
          </svg> Go Back</button
        >
      </div>

      {#if Object.keys(currentEvent).length > 0}
      <!-- Header page -->
      <div
      class="headerInformation"
      style="--event-Wallpaper: {eventWallpaper}; background-image: url({eventWallpaper});"
    >
      <div class="imgContainer">
        <img src={currentEvent.eventMultimedia.eventImgUrl} alt="event poster" />
      </div>
      <div class="meetingsBtns">
        <button
          class="actionBtn"
          on:click={() => navigate(`/myChats/${currentEvent.id}/${currentEvent.tittle}`)}
          on:keypress={() =>
            navigate(`/myChats/${currentEvent.id}/${currentEvent.tittle}`)}
          style="--event-color: {colorBtn};">Chats</button
        >
        {#each currentEvent.eventButtons as button}
        {#if button.isAvailable}
        {#if $userRealTime.userRole !== "attendee"}
        {#if button.buttonUrl.slice(0, 1) === "#"}
          <button
            on:click={()=>document.getElementById(`${button.buttonUrl.slice(1)}`).scrollIntoView({ behavior: "smooth" })}
            on:keypress={document
              .getElementById(`${button.buttonUrl.slice(1)}`)
              .scrollIntoView({ behavior: "smooth" })}
            class="actionBtn"
            style="--event-color: {colorBtn};"
            >{button.buttonTittle}
          </button>
        {:else}
          <a href={button.buttonUrl} target="_blank" rel="noopener noreferrer">
            <button class="actionBtn" style="--event-color: {colorBtn};"
              >{button.buttonTittle}
            </button>
          </a>
        {/if}
      {:else if !button.isAssignedButton}
      {#if button.buttonUrl.slice(0, 1) === "#"}
          <button
            on:click={()=>document.getElementById(`${button.buttonUrl.slice(1)}`).scrollIntoView({ behavior: "smooth" })}
            on:keypress={document
              .getElementById(`${button.buttonUrl.slice(1)}`)
              .scrollIntoView({ behavior: "smooth" })}
            class="actionBtn"
            style="--event-color: {colorBtn};"
            >{button.buttonTittle}
          </button>
        {:else}
        <a href={button.buttonUrl} target="_blank" rel="noopener noreferrer">
          <button class="actionBtn" style="--event-color: {colorBtn};"
            >{button.buttonTittle}
          </button>
        </a>
        {/if}
      {:else if button.isAssignedButton && $userRealTime.customButtons.includes(button.id)}
        <a href={button.buttonUrl} target="_blank" rel="noopener noreferrer">
          <button class="actionBtn" style="--event-color: {colorBtn};"
            >{button.buttonTittle}
          </button>
        </a>
      {/if}
        {/if}
          
        {/each}
      </div>
    </div>
    <!-- End Section -->
      {/if}

      <div class="headerSection">
        <h1>My Meetings</h1>
      </div>
      <div class="filterBottonsContainer">
        <div class="form-floating">
          <select
            class="form-select breakSelect"
            name="company"
            id="floatingSelect"
            aria-label="Floating label select example"
            on:change={filterMeetingsForBreak}
          >
            <option selected value="">Select a break</option>
            {#each breaksNames as element}
              <option value={element.id}>{element.breakTittle}</option>
            {/each}
          </select>
          <label for="floatingSelect">Networking Break</label>
        </div>
        <div class="form-floating">
          <select
            class="form-select statusSelect"
            name="company"
            id="floatingSelect"
            aria-label="Floating label select example"
            on:change={filterAttendees}
          >
            <option selected value="">Select a meeting status</option>
            <option value="accepted">Accepted</option>
            <option value="declined">Declined</option>
            <option value="pending">Pending</option>
          </select>
          <label for="floatingSelect">Meeting Status</label>
        </div>

        <!-- <button
              class="actionButton filterBtn"
              on:click={() => filterAttendees()}>Search</button
            > -->
        <button
          class="actionButton filterBtn"
          on:click={() => {
            resetDocuments();
          }}>Reset</button
        >
      </div>
      <div class="bodySection">
        {#if dinamicMeets.length > 0}
          {#each dinamicMeets as meet}<!-- 
            <MeetsCard
              cardContent={meet}
              colorBtn={$eventRealTime.colorEvent}
            /> -->
            {#if meet.meetStatus === "accepted" || meet.meetStatus === "Accepted"}
            <MeetsCard
              cardContent={meet}
              colorBtn={"green"}
            />
              {:else if meet.meetStatus === "pending" || meet.meetStatus === "Pending"}
              <MeetsCard
                cardContent={meet}
                colorBtn={"yellow"}
              />
              {:else}
              <MeetsCard
                cardContent={meet}
                colorBtn={"red"}
              />
            {/if}
          {/each}
        {:else}
          <section class="emptyContent">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              fill="currentColor"
              class="bi bi-journal-bookmark-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M6 1h6v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8z"
              />
              <path
                d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"
              />
              <path
                d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
              />
            </svg>
            <p class="emptyText">There are no meetings with this parameters.</p>
          </section>
        {/if}
      </div>
    </body>
  {:else}
    <Loader />
  {/if}
{/if}

{#if $isAlertOn}
  <AlertModal />
{/if}
{#if $isChatModalOn}
  <ChatModal />
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  body {
    width: 100%;
    height: auto;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f4f4f4;
  }
  /* Back btn styles */
  .backBtnContainer {
    width: 90%;
    display: flex;
    justify-content: flex-start;
  }
  .backBtn {
    background-color: #f4f4f4;
    border: none;
  }
  .backBtn:hover {
    color: #ed2824;
    border-bottom: 1px solid #ed2824;
  }

  
  /* Hedaer styles */
  .headerInformation {
    width: 90%;
    background-size: cover;
    background-position: center;
    display: flex;
    padding: 25px;
    margin: 10px 0;
  }
  .imgContainer {
    width: 50%;
  }
  .meetingsBtns {
    background-color: rgba(0, 0, 0, 0.425);
    width: 70%;
    max-height: 50vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 0;
  }
  .actionBtn {
    width: 200px;
    height: 50px;
    font-size: 20px;
    font-weight: 400;
    border-radius: 12px;
    padding: 8px 16px;
    color: var(--event-color);
    border: 1px solid var(--event-color);
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
    background-color: white;
  }

  .actionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: var(--event-color);
    color: White;
  }
  img {
    width: 85%;
    height: auto;
  }

  /* Header Styles */
  .headerSection {
    width: 90%;
    padding: 15px;
    border-bottom: 1px solid gray;
  }

  .bodySection {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 90%;
    height: auto;
    padding: 15px;
  }
  .filterBottonsContainer {
    width: 90%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
    padding: 10px 0;
  }
  .form-floating {
    margin: 0 10px;
    width: 250px;
  }
  .filterBtn {
    height: 40px;
    width: 100px;
  }
  .actionButton {
    width: 200px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
  }

  .actionButton:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  /* Empty styles */
  .emptyContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 30vh;
    padding: 20px;
  }
  .emptyText {
    margin-top: 5px;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .bodySection {
      width: 100%;
      height: auto;
      padding: 15px 5px;
    }
    .headerSection {
      width: 100%;
      padding: 10px;
    }
    .filterBottonsContainer {
      width: 100%;
    }

    .meetingsBtns {
      background-color: rgba(0, 0, 0, 0.425);
      width: 100%;
      height: auto;
      max-height: 15dvh;
      overflow: auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 10px 0;
    }
    img {
      width: 100%;
      height: auto;
    }

  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .filterBottonsContainer {
      width: 100%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 10px;
    }
    .form-floating {
      margin: 5px 0;
      width: 100%;
    }
    .filterBtn {
      font-size: 20px;
      padding: 10px;
      height: auto;
      width: 100%;
      margin: 10px 0;
    }
    .bodySection {
      width: 100%;
      height: auto;
      padding: 15px 5px;
    }

    .headerInformation {
      width: 100%;
      height: auto;
      max-height: 2000dvh;
      flex-direction: column;
      align-items: center;
      padding: 0;
    }
    .imgContainer {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .meetingsBtns {
      background-color: rgba(0, 0, 0, 0);
      width: 100%;
      height: auto;
      max-height: auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 20px 0;
    }
    .actionBtn {
      width: 150px;
      height: auto;
      font-size: 20px;
      font-weight: 500;
      padding: 10px 0;
      background-color: white;
      margin: 5px;
    }
  }
  /* End of the section */
</style>
